module.exports = __webpack_public_path__ + "static/img/switch-2.6896357.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UC3880/switch-2.jpg
// module id = ETAE
// module chunks = 51